// libraries
import Api from "@/_helpers/Api"
import { BarChart } from "@mui/x-charts"
import { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"

export default function FinancesMain() {
  const statusColors = {
    incomes: "#35B084",
    expenses: "#FF718B",
    vat: "#C893FD",
    tax: "#F9B578",
  }

  const statusLabels = {
    incomes: "Приходи",
    expenses: "Разходи",
    vat: "ДДС",
    tax: "Данък печалба",
  }

  const [state, setState] = useState({
    loading: true,
    data: [],
  })

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }))

    Api.get("accounts/yearly-summary")
      .then((res) => {
        setState((prev) => ({
          ...prev,
          data: res.data || [],
        }))
      })
      .finally(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const formatCurrency = (value) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M ${state.data[0].currency.name}`
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K ${state.data[0].currency.name}`
    }
    return `${value.toFixed(2)} ${state.data[0].currency.name}`
  }

  const valueFormatter = (value) => formatCurrency(value)

  return (
    <div className="todos-stats-chart">
      <div className="head">
        <h3>Финанси</h3>
        <ul>
          {Object.entries(statusLabels).map(([status, label]) => (
            <li key={status}>
              <span style={{ backgroundColor: statusColors[status] }} />
              {label}
            </li>
          ))}
        </ul>
      </div>
      <hr />
      {state.loading ? (
        <Skeleton height={240} count={1} />
      ) : (
        <BarChart
          dataset={state.data}
          xAxis={[
            {
              scaleType: "band",
              dataKey: "year",
            },
          ]}
          series={[
            {
              dataKey: "incomes",
              // label: statusLabels.incomes,
              valueFormatter: (value, context) => {
                const item = state.data[context.dataIndex]
                if (!item || !item.paymentMethods) return formatCurrency(value)

                const methods = item.paymentMethods
                return (
                  <table
                    style={{
                      borderCollapse: "collapse",
                      marginLeft: "-15px",
                      width: "250px",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "5px 0",
                          }}
                        >
                          PayPal:
                        </td>
                        <td
                          style={{
                            padding: "5px 0",
                          }}
                          className="right"
                        >
                          {formatCurrency(methods.paypal)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 0" }}>ePay:</td>
                        <td style={{ padding: "5px 0" }} className="right">
                          {formatCurrency(methods.epay)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "5px 0" }}>Банков превод:</td>
                        <td style={{ padding: "5px 0" }} className="right">
                          {formatCurrency(methods.bank_transfer)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "5px 0",
                          }}
                        >
                          В брой:
                        </td>
                        <td style={{ padding: "5px 0" }} className="right">
                          {formatCurrency(methods.cash)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "5px 0",
                            paddingBottom: "15px",
                          }}
                        >
                          С карта:
                        </td>
                        <td
                          style={{
                            padding: "5px 0",
                            paddingBottom: "15px",
                          }}
                          className="right"
                        >
                          {formatCurrency(methods.card)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            borderTop: "1px solid #2c2c2c",
                            padding: "5px 0",
                            paddingTop: "15px",
                          }}
                        >
                          ОБЩО:
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid #2c2c2c",
                            padding: "5px 0",
                            paddingTop: "15px",
                          }}
                          className="right"
                        >
                          {formatCurrency(methods.total)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )
              },
              color: statusColors.incomes,
            },
            {
              dataKey: "expenses",
              label: statusLabels.expenses,
              valueFormatter,
              color: statusColors.expenses,
            },
            {
              dataKey: "vat",
              label: statusLabels.vat,
              valueFormatter,
              color: statusColors.vat,
            },
            {
              dataKey: "tax",
              label: statusLabels.tax,
              valueFormatter,
              color: statusColors.tax,
            },
          ]}
          height={400}
          margin={{
            right: 0,
          }}
          slotProps={{
            legend: { hidden: true },
            itemContent: {
              sx: {
                "& .MuiChartsTooltip-mark": { display: "none" },
                "& .MuiChartsTooltip-cell": { paddingLeft: "0 !important" },
              },
            },
          }}
          tooltip={{ trigger: "item" }}
          borderRadius={4}
        />
      )}
    </div>
  )
}
